//export const ip = "172.23.192.34";
//export const apiUrl = `http://${ip}/api`;
export const isMobile = false;
